export default __webpack_public_path__ + "static/media/ic_my-memos.77c940da.svg";